import React, { Component, Fragment } from 'react';
import {
    Input,
    Button,
    Row,
    Col, Label
} from 'reactstrap';
import './Contacts.css';
import NotesCategoriesDisplay from '../Notes/NotesCategoriesDisplay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons'
import PermissionWrapper from '../../auth/PermissionWrapper';

class AddContact extends Component {

    constructor(props) {

        super(props);
        this.state = {
            displayCategories: this.props.displayCategories,
            add: false
        };

    }

    checkPermission = (permission) => {
        return permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
    }

    render() {
        return (<>
            {this.state.add ?
                <Row>
                    {this.props.selectValue !== 3 && this.props.selectValue !== 9 && this.props.selectValue !== 10 && this.props.selectValue !== 4 && this.props.selectValue !== 27 && <Col md={5} className="notesFormInputType text-left">
                        <NotesCategoriesDisplay clientToken={this.props.clientToken} value={this.props.selectValue} name="noteType" onChange={this.props.displayCategories} data={this.props.notesCategories} noteData={this.props.notes} />
                    </Col>}
                    <Col md={5} className="text-left pl-3">
                        {this.props.addCategoryCommentsArray.map(row => {
                            switch (row.validation) {
                                case "list":
                                    return (
                                        <Fragment key={row.ID}>
                                            <Row className="mb-2 mx-0">
                                                <Label>{row.type}</Label>
                                                <Input type="select" name={row.ID}
                                                    onChange={this.props.setComment}
                                                    value={row.value}
                                                >
                                                    <option value="0">Select {row.type}</option>
                                                    {row.list != null && row.list
                                                        .filter(item => item.longDescription !== 'Other' || (this.checkPermission('Create Other List Item') && item.longDescription === 'Other'))
                                                        .map(item => (
                                                            <option key={item.ID} value={item.ID}>{item.longDescription}</option>
                                                        ))}
                                                </Input>
                                            </Row>
                                            {(this.props.notesCategories.data.reduce((childArray, currentValue) => childArray.concat(currentValue.children), [])
                                                .reduce((listArray, listValue) => listValue.list != null ? listArray.concat(listValue.list) : listArray, [])
                                                .findIndex(item => item.ID === parseInt(row.value) && item.longDescription === 'Other') > -1) ?
                                                <Row>
                                                    <PermissionWrapper {...this.props} allowedPermission="Create Other List Item" hidden={true}>
                                                        <Col md={9} className="px-1 py-1">
                                                            <Input type="text" value={this.props.otherCategories[row.ID]} onChange={(e) => this.props.changeOtherCategory(row.ID, e.target.value)} />
                                                        </Col>
                                                        <Col className="py-1 text-left p-0">
                                                            <Button
                                                                color="success"
                                                                onClick={() => this.props.addCategory(row.ID, this.props.otherCategories[row.ID], 'add')}
                                                                title="Add Other"
                                                            ><FontAwesomeIcon icon={faPlus} /></Button>
                                                        </Col>
                                                    </PermissionWrapper>
                                                </Row>
                                                : <></>
                                            }
                                        </Fragment>
                                    )
                                case "date":
                                    const d = new Date();
                                    const today = (d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).substr(-2) + '-' + ('0' + d.getDate()).substr(-2));
                                    if ((row.value == null || row.value === '') && String(row.validationHint).toLowerCase() === 'today') row.value = today;
                                    return (
                                        <Row key={row.ID} className="mb-2 mx-0">
                                            <Label>{row.type}</Label>
                                            <Input
                                                name={row.ID}
                                                onChange={this.props.setComment}
                                                type="date"
                                                value={row.value || null}
                                            // placeholder={row.type}
                                            />
                                        </Row>
                                    )
                                case "checkbox":
                                    return (
                                        <Row key={row.ID} className="mb-2 pl-4 mx-0">
                                            <Label>{row.type}</Label>
                                            <Input
                                                name={row.ID}
                                                onChange={this.props.setComment}
                                                type="checkbox"
                                            />
                                            {row.type}
                                        </Row>
                                    )
                                case null:
                                    return (
                                        <Row key={row.ID} className="mb-2 mx-0">
                                            <Label>{row.type}</Label>
                                            <Input
                                                // placeholder={row.type}
                                                name={row.ID}
                                                onChange={this.props.setComment}
                                                type={row.multiline ? 'textarea' : 'text'}
                                            />
                                        </Row>
                                    )
                                default:
                                    return (
                                        <Row key={row.ID} className="mb-2 mx-0">
                                            <Label>{row.type} {(row.validationHint != null) ? <span className="validationHint">({row.validationHint})</span> : <></>}</Label>
                                            <Input
                                                // placeholder={row.type + ' ' + ((row.validationHint != null) ? '(' + row.validationHint + ')' : '')}
                                                className={row.error ? "is-invalid" : ''}
                                                name={row.ID} onChange={(e) => this.props.setComment(e, row.validation)}
                                                type={row.multiline ? 'textarea' : 'text'} />
                                        </Row>
                                    )
                            }
                        })}
                    </Col>
                    <Col sm="2" className="text-right notesFormTypeControls">
                        {/* {this.props.addCategoryCommentsArray.length > 0 ? ( */}
                        <Button
                            title="Add Contact"
                            key="buttonAdd"
                            color="success"
                            onClick={() => { this.props.handleAddSubmit(); this.setState({ add: false }) }}
                            disabled={this.props.addCategoryCommentsArray.length === 0 && (this.props.loading ||
                                this.props.isFormBlank(this.props.addCategoryCommentsArray) ||
                                this.props.addCategoryCommentsArray.filter(item => item.error).length > 0)}
                        ><FontAwesomeIcon icon={this.props.loading ? faSpinner : faPlus} title="Add" /></Button>
                        <Button
                            key={'buttonCancel'}
                            color="secondary"
                            onClick={() => this.setState({ add: false }, () => this.props.handleCancel())}
                            title="Cancel"
                        ><FontAwesomeIcon icon={faTimes} /></Button>
                        {/* ) : (<></>)} */}
                    </Col>
                </Row>
                : <Row className='text-left'><Col>
                    <Button onClick={() => { this.setState({ add: true }); this.props.displayCategories({ target: { value: 3 } }) }} color="primary" className='mr-2'>Add Contacts</Button>
                    <Button onClick={() => { this.setState({ add: true }); this.props.displayCategories({ target: { value: 9 } }) }} color="primary" className='mr-2'>Add Company Info</Button>
                    {this.props.notes.findIndex(item => item.typeID === 10) === -1 && <Button onClick={() => { this.setState({ add: true }); this.props.displayCategories({ target: { value: 10 } }) }} color="primary" className='mr-2'>Add Company Characteristics</Button>}
                    <Button onClick={() => { this.setState({ add: true }); this.props.displayCategories({ target: { value: 27 } }) }} color="primary" className='mr-2'>Add Sales Activity</Button>
                    <Button onClick={() => { this.setState({ add: true }); this.props.displayCategories({ target: { value: 4 } }) }} color="primary" className='mr-2'>Add Note</Button>
                    <Button onClick={() => this.setState({ add: true })} color="primary" className='mr-2'>Add Misc</Button>
                </Col></Row>}
        </>
        )
    }
}

export default AddContact;
